import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from '../../services/user.service';

import { UntypedFormBuilder } from '@angular/forms';
import { FormHelperService } from "../../services/form-helper.service";
import { ToastService } from "../../services/toast.service";
import { ReferentielService } from "../../services/referentiel.service";
import { BackResourceService } from "../../services/back-resource.service";
import { LoaderService } from "../../services/loader.service";
import { Image } from "../../models/image";

@Component({
    selector: 'app-compte',
    templateUrl: './compte.component.html',
    styleUrls: ['./compte.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompteComponent implements OnInit {

  referentiels: any = null;

  image = new Image();

  form = this.fb.group({
    genre: [],
    nom: [],
    prenom: [],
    adresseEmail: [],
    plainPassword: this.fb.group({
      first: [],
      second: []
    }),
    adresse: [],
    deletePhoto: [false]
  });

  @ViewChild('adresseComponent')
  adresseComponent;

  constructor(private userService: UserService,
              private referentielService: ReferentielService,
              private fb: UntypedFormBuilder,
              private fh: FormHelperService,
              private toastService: ToastService,
              private backResource: BackResourceService,
              public loaderService: LoaderService
  ) {
  }

  ngOnInit() {
    this.loadUser();
    this.loadReferentiels();
  }

  private loadUser() {
    this.userService.load().then((user) => {
      this.image = new Image(user.photo ? (this.backResource.getUrl(user.photo)) : null);
      this.form.patchValue(user);
    });
  }

  private loadReferentiels() {
    this.referentielService.all().then((referentiels) => {
      this.referentiels = referentiels;
    });
  }

  save() {
    const user = this.form.getRawValue();
    user.photo = {binaryContent: this.image.current === this.image.original ? null : this.image.file};
    this.userService.save(user).then((response) => {
      this.toastService.show(response.message, {classname: 'toast-' + response.status});
      if (response.status == 'error') {
        this.fh.setSymfonyFormErrors(this.form, response.errors, true);
        this.fh.setSymfonyFormErrors(this.adresseComponent.form, response.errors.adresse);
      }
    });
  }

  updateImage(image) {
    this.form.get('deletePhoto').setValue(false);
    this.image = image;
  }

  deleteImage(image) {
    this.form.get('deletePhoto').setValue(true);
  }
}
